import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f18d4110"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "m-reward" }
const _hoisted_2 = { class: "m-reward-image" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "m-reward-info" }
const _hoisted_5 = {
  key: 0,
  class: "m-reward-wallet-limit"
}
const _hoisted_6 = { class: "m-reward-badges" }
const _hoisted_7 = {
  key: 0,
  class: "m-reward-num-copies"
}
const _hoisted_8 = {
  key: 1,
  href: "https://delegate.cash/",
  target: "_blank",
  rel: "noopener noreferrer"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_lazy_image = _resolveComponent("lazy-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.reward.token.image)
        ? (_openBlock(), _createBlock(_component_lazy_image, {
            key: 0,
            src: _ctx.reward.token.image
          }, null, 8, ["src"]))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _ctx.brokenImageIcon
          }, null, 8, _hoisted_3))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("span", null, _toDisplayString(_ctx.reward.token.name || 'Token Name'), 1),
      _createElementVNode("span", null, _toDisplayString(_ctx.reward.token.tokenId), 1),
      (_ctx.walletLimitReached)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Wallet Limit Reached "))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        (_ctx.reward.token.remaining > 1)
          ? (_openBlock(), _createElementBlock("span", _hoisted_7, " x" + _toDisplayString(_ctx.reward.token.remaining), 1))
          : _createCommentVNode("", true),
        (_ctx.reward.token.eip5131 || _ctx.reward.token.eip5639)
          ? (_openBlock(), _createElementBlock("a", _hoisted_8, [
              _createElementVNode("img", {
                class: "m-reward-delegate-cash-icon",
                src: _ctx.delegateCashIcon
              }, null, 8, _hoisted_9)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    (_ctx.cta)
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          disabled: _ctx.addingToCart || _ctx.walletLimitReached,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clickHandler(_ctx.reward)))
        }, [
          _createTextVNode(_toDisplayString(_ctx.cta) + " ", 1),
          (_ctx.reward.reward && _ctx.reward.reward.discountPercent)
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(_ctx.reward.reward.discountPercent) + "% off ", 1))
            : (_ctx.reward.reward && _ctx.reward.reward.discountAmount)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(_ctx.reward.reward.discountAmount) + " USD off ", 1))
              : _createCommentVNode("", true)
        ], 8, _hoisted_10))
      : _createCommentVNode("", true)
  ]))
}